import React from 'react';
import {useTranslation} from 'react-i18next';
import {YesNoModal} from '../../elements/YesNoModal';
import {FaIcon} from '../../FaIcon';
import {ChannelLogo} from '../../channels/ChannelLogo';

/**
 * La fila de una cuenta de la familia «Rentabilidad del negocio» (una organización de Escalafy) en las
 * conexiones del cliente: nombre, estado y para qué sirve. Sin límite diario, presupuesto, eventos ni
 * campañas, que no existen en esta familia. Desvincular no toca la conexión de la agencia: la
 * organización deja de alimentar la economía del cliente y lo importado queda como historial.
 */
export function ClientProfitabilityRow({clientAdAccount, showClientColumn = false, onRemove, isSaving = false}) {
    const {t} = useTranslation();
    const account = clientAdAccount;
    const ok = account.has_access !== false && !account.has_internal_problem;
    const icon = ok ? 'check' : 'exclamation-triangle';

    return (
        <tr className="client-profitability-row" data-testid={`client-profitability-row-${account.id}`}>
            <td style={{paddingLeft: '0.4em'}}>
                <div style={{display: 'flex', alignItems: 'center', minWidth: '12em', padding: '10px 0'}}>
                    <ChannelLogo useOld={false} width="20px" height="20px" channel={account.channel} marginLeft="5px"/>
                    <span>
                        <span style={{display: 'block'}}>{account.name}</span>
                        <span className="field-footnote-darker" style={{display: 'block'}}>
                            {t('clients.escalafy_row_hint')}
                        </span>
                    </span>
                </div>
            </td>
            {showClientColumn && <td>{account.agency_client_name}</td>}
            <td>
                <div className="access-status-cell">
                    <div className={`bu-cell-icon${ok ? '' : ' no-impressions-alert'}`}>
                        <FaIcon iconName={icon}/>
                        <div className="bu-tooltip">
                            <FaIcon iconName={icon}/>
                            <p className="tooltip-description">
                                {account.has_access === false && (
                                    <span style={{fontWeight: '600'}}>
                                        {t('clients.no_access_since')} {account.no_access_since}<br/>
                                    </span>
                                )}
                                {t('clients.last_check')} {account.last_access_check}
                            </p>
                        </div>
                    </div>
                </div>
            </td>
            <td>
                <span style={{marginLeft: '5px'}}>
                    <YesNoModal onYesAnswer={() => onRemove(account.id)}
                                title={t('economics.escalafy.unlink')}
                                message={t('economics.escalafy.unlink_confirm')}
                                question=""
                                buttonClassName=""
                                buttonText=""
                                buttonTitle={t('economics.escalafy.unlink')}
                                buttonIconName="minus-square"
                                isSaving={isSaving}
                    />
                </span>
            </td>
        </tr>
    );
}

export default ClientProfitabilityRow;
